<template>
    <div v-on:click="edit" class="inline-input">
        <img width="28px" :style="css" :src="getIcon(initialValue) || '/icons/assets/file.png'" class="m-2" />
        <!-- <i> (Click to edit)</i><br> -->
        <i class="material-icons inline-input-icon">edit</i><br>
        <!-- <a :href="initialValue.link + '?download'" target="_blank">Download</a> -->
    </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';

export default {
    data() {
        return {
            value: this.initialValue,
            active: false,
        }
    },

    components: { },

    props: ['initialValue', 'css', 'schema'],

    watch: {
        selectedAsset(newAsset) {
            if (!this.active) return;
            if (_.get(newAsset, 'id') == _.get(this.initialValue, 'id')) return;
            this.$emit('change', newAsset);
            this.active = false;
        }

    },

    computed: {
        ...Vuex.mapGetters('assets', {
            assets: 'content',
            selectingAsset: 'selectingAsset',
            selectedAsset: 'selectedAsset',
            fileModalOpen: 'fileModalOpen',
            fileModalConfig: 'fileModalConfig',
        }),
    },

    methods: {
        ...Vuex.mapActions('assets', {
            selectAsset: 'selectAsset',
            commitAsset: 'commitAsset',
            closeAssetModal: 'closeAssetModal',
            openAssetModal: 'openAssetModal',
            configAssetModal: 'configAssetModal',
        }),

        edit() {
            this.configAssetModal({
                multiple: false,
                extensions: _.get(this.schema, 'extensions', []),
                storagePanel: true,
            });
            this.selectAsset(_.get(this.initialValue, 'id'));
            this.commitAsset();
            this.openAssetModal();

            this.$nextTick(() => {
                this.active = true;
            })
        },
        getIcon(value) {
            const extensions = this.config('file.extensions');

            if (_.get(value, 'extension') == 'dir') return '/icons/assets/folder-icon.png';

            return _.chain(extensions)
                .toPairs()
                .filter(([icon, exts]) => {
                    return exts.indexOf(_.get(value, 'extension')) >= 0;
                })
                .map(([icon, exts]) => {
                    switch(icon) {
                        case 'docx':
                        case 'doc': return '/icons/assets/file-doc.png';
                        case 'pdf': return '/icons/assets/file-pdf.png';
                        case 'dir': return '/icons/assets/folder.png';
                        case 'img': return _.imgPath(value, 'w80');
                        default: return '/icons/assets/file.png'
                    }
                })
                .first()
                .value() || '/icons/assets/file.png';
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/InlineGlobalModalAssetComponent.vue